import { extractRequestFromQueryKey } from "../../../keys";
import { FORCE_INVALIDATE } from "../../../utils";
import { modelMatchesGetSomeRequest } from "../filter-utils";
import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const AI_CONVERSATIONS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"ai_conversations"> =
  {
    send_message: (_req, response) => {
      if (!response) {
        return {};
      }

      const conversationFromResponse = response.ai_conversation;

      return {
        _otherModels: {
          // invalidate orgs to get updated creditCount
          organizations: {
            getOne: {
              predicate: () => true,
            },
            getSome: {
              predicate: () => true,
            },
            getByIds: {
              predicate: () => true,
            },
          },
        },
        getSome: {
          predicate: ({ queryKey }) => {
            const queryRequest = extractRequestFromQueryKey(queryKey);
            return modelMatchesGetSomeRequest(conversationFromResponse, queryRequest);
          },
          updater: (oldData) => {
            if (!oldData) return oldData;

            const existsInCache = oldData.pages.some((page) =>
              page.some((conversation) => conversation.id === conversationFromResponse.id)
            );

            if (existsInCache) {
              return {
                ...oldData,
                pages: oldData.pages.map((page) =>
                  page.map((conversation) =>
                    conversation.id === conversationFromResponse.id ? conversationFromResponse : conversation
                  )
                ),
              };
            }

            return FORCE_INVALIDATE;
          },
        },
        getOne: {
          request: { id: conversationFromResponse.id },
          updater: () => conversationFromResponse,
        },
        getByIds: {
          predicate: ({ queryKey }) => {
            const queryRequest = extractRequestFromQueryKey(queryKey);
            return !!queryRequest?.ids?.includes(conversationFromResponse.id);
          },
          updater: (oldData) => {
            if (!oldData) return oldData;

            return {
              ...oldData,
              matches: oldData.matches.map((conversation) =>
                conversation.id === conversationFromResponse.id ? conversationFromResponse : conversation
              ),
            };
          },
        },
      };
    },
  };
